<template>
  <div class="cert-mask"
       ref="mask"
       :style="maskStyle">
    <template v-if="data.type">
      <div class="img-demo" :style="{width: imgWidth, height: imgHeight}">
        图片
      </div>
    </template>
    <template v-else>{{label}}</template>
    <div class="top-border"></div>
    <div class="left-border"></div>
    <div class="right-border"></div>
    <div class="bottom-border"></div>
    <div class="se-corner-border"></div>
    <div class="mask-btns">
      <div class="btn-item editor-icon" title="编辑" @click="$emit('edit')">
      </div>
      <div class="btn-item delete-icon" title="删除" v-if="data && !data.default" @click="$emit('delete')"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CertMask',
    model: {
      prop: 'data',
      event: 'change',
    },
    props: {
      data: {
        type: Object,
      },
      scale: {
        type: Number,
        default: 1,
      },
      faceId: {
        type: Number,
      },
    },
    computed: {
      imgWidth() {
        return `${Math.round(this.data.img_width * this.scale)}px`;
      },
      imgHeight() {
        return `${Math.round(this.data.img_height * this.scale)}px`;
      },
      label() {
        return this.data.demo || '文本框';
      },
      fontSize() {
        return Math.round(this.data.font_size * this.scale);
      },
      left: {
        get() {
          return Math.round(this.data.x * this.scale);
        },
        set(newValue) {
          const x = newValue / this.scale;
          this.data.x = Math.round(x);
        },
      },
      top: {
        get() {
          return Math.round(this.data.y * this.scale);
        },
        set(newValue) {
          const y = newValue / this.scale;
          this.data.y = Math.round(y);
        },
      },
      width: {
        get() {
          return this.data.width ? Math.round(this.data.width * this.scale) : 80;
        },
        set(newValue) {
          const w = Math.round(newValue / this.scale);
          this.$set(this.data, 'width', w);
        },
      },
      height: {
        get() {
          let h;
          if (this.data.type) {
            h = Math.round(this.data.img_height * this.scale);
          }
          else {
            h = Math.round(this.data.font_size * this.scale);
          }
          return h;
        },
        set(newValue) {
          const h = Math.round(newValue / this.scale);
          if (!this.data.type) {
            this.$set(this.data, 'font_size', h);
          }
        },
      },
      color: {
        get() {
          return this.data.color ? this.data.color : 'red';
        },
      },
      maskStyle() {
        return {
          cursor: this.isMoving ? 'move' : 'default',
          left: `${this.left}px`,
          top: `${this.top}px`,
          width: `${this.width}px`,
          height: `${this.height}px`,
          lineHeight: `${this.height}px`,
          fontSize: `${this.fontSize}px`,
          color: `${this.color}`,
          textAlign: `${this.data.align}`,
          fontFamily: this.faceId ? `myFont_${this.faceId}` : null,
        };
      },
    },
    data() {
      return {
        x0: null,
        y0: null,
        isResizing: false,
        isMoving: false,
        startScrollTop: 0,
      };
    },
    mounted() {
      const {mask} = this.$refs;
      document.body.onscroll = this.mouseScorll;
      mask.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        this.x0 = e.x;
        this.y0 = e.y;
        this.isMoving = true;
        this.startScrollTop = document.scrollingElement.scrollTop;
        this.maxWidth = window.parseFloat(getComputedStyle(mask.parentElement).width);
        this.maxHeight = window.parseFloat(getComputedStyle(mask.parentElement).height);
        document.onmousemove = this.mouseMove;
        document.onmouseup = this.mouseUp;
      });
      mask.querySelector('.right-border').addEventListener('mousedown', (e) => {
        e.stopPropagation();
        this.x0 = e.x;
        this.y0 = e.y;
        this.startResize();
        document.onmousemove = this.resizeWidthMouseMove;
        document.onmouseup = this.resizeUp;
      });

      mask.querySelector('.bottom-border').addEventListener('mousedown', (e) => {
        e.stopPropagation();
        this.x0 = e.x;
        this.y0 = e.y;
        this.startResize();
        document.onmousemove = this.resizeHeightMouseMove;
        document.onmouseup = this.resizeUp;
      });
      mask.querySelector('.se-corner-border').addEventListener('mousedown', (e) => {
        e.stopPropagation();
        this.x0 = e.x;
        this.y0 = e.y;
        this.startResize();
        document.onmousemove = this.resizeCornerMove;
        document.onmouseup = this.resizeUp;
      });
    },
    methods: {
      startResize() {
        this.isResizing = !this.data.type;
      },
      resizeUp() {
        this.isResizing = false;
        this.x0 = null;
        this.y0 = null;
      },
      resizeCornerMove(e) {
        this.resizeWidthMouseMove(e);
        this.resizeHeightMouseMove(e);
      },

      mouseScorll(e) {
        if (this.isMoving) {
          this.top += e.target.scrollingElement.scrollTop - this.startScrollTop;
          this.startScrollTop = e.target.scrollingElement.scrollTop;
        }
      },
      resizeWidthMouseDown(e) {
        this.isResizing = true;
        this.x0 = e.x;
        this.y0 = e.y;
      },
      resizeWidthMouseMove(e) {
        if (this.isResizing) {
          this.width += e.x - this.x0;
          if (this.width + this.left > this.maxWidth) {
            this.width = this.maxWidth - this.left;
          }
          this.x0 = e.x;
        }
      },
      resizeHeightMouseMove(e) {
        if (this.isResizing) {
          this.height += e.y - this.y0;
          if (this.height + this.top > this.maxHeight) {
            this.height = this.maxHeight - this.top;
          }
          this.y0 = e.y;
        }
      },
      mouseMove(e) {
        if (this.isMoving) {
          this.left += e.x - this.x0;
          this.top += e.y - this.y0;
          if (this.top < 0) {
            this.top = 0;
          }
          if (this.left < 0) {
            this.left = 0;
          }
          if (this.top + this.height > this.maxHeight) {
            this.top = this.maxHeight - this.height;
          }
          if (this.left + this.width > this.maxWidth) {
            this.left = this.maxWidth - this.width;
          }
          this.x0 = e.x;
          this.y0 = e.y;
        }
      },
      mouseUp() {
        this.isMoving = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cert-mask {
    user-select: none;
    position: absolute;
    box-sizing: border-box;
    z-index: 3;
    background: rgba(255, 33, 33, .3);
    color: #000;
    .img-demo {
      background-color: #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .mask-btns {
      position: absolute;
      width: 100%;
      height: 30px;
      top: -30px;
      bottom: 0;
      .btn-item {
        position: absolute;
        width: 30px;
        height: 30px;
        z-index: 10;
        cursor: pointer;
        color: #444;
      }
      .editor-icon {
        top:0;
        left: 0;
        background-image: url("/images/bianji.png");
        background-size: cover;
      }
      .delete-icon {
        transform: translateX(100%);
        background-image: url("/images/shanchu.png");
        background-size: cover;
      }
    }
    [class$=border] {
      position: absolute;
      border: 1px dashed rgba(255, 3, 3, 0.8);
    }
    [class^=right] {
      cursor: ew-resize;
      right: 0;
      top: 1px;
      bottom: 1px;
    }
    [class^=bottom] {
      cursor: ns-resize;
      left: 1px;
      right: 1px;
      bottom: 0;
    }
    [class^=top] {
      left: 1px;
      right: 1px;
      top: 0;
    }
    [class^=left] {
      left: 0;
      top: 1px;
      bottom: 1px;
    }
    .se-corner-border {
      right: 0;
      bottom: 0;
      cursor: nwse-resize;
    }

  }
</style>
